import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPassport, FaCamera, FaFileAlt, FaInfoCircle, FaRegClock, FaGlobe } from 'react-icons/fa';

const ViewVisaAssistance = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const visaPackage = state?.visaPackage;
 useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [state]);
  
  if (!visaPackage) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800">No visa package found</h2>
          <button 
            onClick={() => navigate('/visa-assistance')}
            className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Back to Visa Assistance
          </button>
        </div>
      </div>
    );
  }



  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-blue-600 hover:text-blue-800 mb-6 transition-colors"
        >
          <FaArrowLeft className="mr-2" /> Back to Visa Assistance
        </button>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="relative h-64 md:h-80">
            <img
              src={visaPackage.image}
              alt={visaPackage.alt}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <h1 className="absolute bottom-6 left-6 text-3xl md:text-4xl font-bold text-white">
              {visaPackage.country}
            </h1>
          </div>

          <div className="p-6 md:p-8">
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Visa Options</h2>
                <div className="grid gap-4">
                  {visaPackage.visas.map((visa, idx) => (
                    <div key={idx} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <h3 className="text-lg font-semibold text-blue-600">{visa.title}</h3>
                      <div className="mt-2 grid grid-cols-2 gap-2 text-sm text-gray-700">
                        <div><span className="font-medium">Type:</span> {visa.type}</div>
                        <div><span className="font-medium">Stay:</span> {visa.stay}</div>
                        {visa.validity && <div><span className="font-medium">Validity:</span> {visa.validity}</div>}
                        <div className="flex items-center">
                          <FaRegClock className="mr-1 text-blue-500" />
                          <span className="font-medium">Processing:</span> {visa.processing}
                        </div>
                        {visa.entries && <div><span className="font-medium">Entries:</span> {visa.entries}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Required Documents</h2>
                <ul className="space-y-2">
                  {visaPackage.document.map((doc, idx) => (
                    <li key={idx} className="flex items-start">
                      <FaFileAlt className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                      <span>{doc}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {visaPackage.note && (
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                  <h3 className="font-semibold text-yellow-800 mb-2 flex items-center">
                    <FaInfoCircle className="mr-2" /> Important Notes
                  </h3>
                  <ul className="text-yellow-700 space-y-1">
                    {visaPackage.note.map((note, idx) => (
                      <li key={idx} className="flex items-start">
                        <span>• {note}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="pt-4 border-t border-gray-200">
                <button
                  onClick={() => navigate('/contact')}
                  className="w-full md:w-auto px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
                >
                  Apply for Visa
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewVisaAssistance;
